import { useCallback } from 'react';
import {
  Thread,
  ArtifactType,
  isArtifactMarkdown,
  isArtifactCode,
} from 'src/types';
import { getLanguageKey } from 'src/utils';
import { useInsertTextToEditor } from './useInsertTextToEditor';
import { useCodeEditorActions } from './useCodeEditorActions';
import { useInsertCodeToEditor } from './useInsertCodeToEditor';
import { useClearCodeEditor } from './useClearCodeEditor';
import { useClearEditorText } from './useClearEditorText';

export const useInsertLoadedContentToEditor = () => {
  const { insertTextToEditor } = useInsertTextToEditor();
  const { setCodeEditorData } = useCodeEditorActions();
  const { insertCodeToEditor } = useInsertCodeToEditor();
  const { clearEditorText } = useClearEditorText();
  const { clearCodeEditorContent } = useClearCodeEditor();

  const onInsertLoadedContent = useCallback(
    (thread: Thread) => {
      const { thread_type, artifact } = thread;
      const contents = artifact?.contents;
      const currentIndex = artifact?.currentIndex;
      const currentArtifact =
        typeof currentIndex === 'number'
          ? contents?.find((item) => item.index === currentIndex)
          : null;

      if (thread_type === ArtifactType.TEXT) {
        clearEditorText();
      }

      if (isArtifactMarkdown(currentArtifact)) {
        insertTextToEditor({ markdown: currentArtifact.fullMarkdown });
      }

      if (thread_type === ArtifactType.CODE && !currentArtifact) {
        setCodeEditorData(null);
      }

      if (thread_type === ArtifactType.CODE) {
        clearCodeEditorContent();
      }

      if (isArtifactCode(currentArtifact)) {
        const { code, language } = currentArtifact;
        setCodeEditorData({
          content: code,
          language: getLanguageKey(language),
        });
        // TODO(olha): WIP Editor check if we can read a coder data from cache
        insertCodeToEditor({ codeContent: code });
      }
    },
    [
      insertCodeToEditor,
      setCodeEditorData,
      clearCodeEditorContent,
      insertTextToEditor,
      clearEditorText,
    ],
  );

  return { onInsertLoadedContent };
};
